import { takeLatest, call, select, put } from "redux-saga/effects";
import api from "../../../services/api";
import {
  submitGetLiveAccountsRequest,
  submitGetLiveAccountsSuccess,
  submitGetLiveAccountsFailure,
  SUBMIT_GET_LIVE_ACCOUNTS_REQUEST
} from "../actions/fetchLiveAccountsActions";
import { fetchLiveAccountsAgent } from "../../../services/accIqService";

function* submitGetLiveAccountsSaga(action) {

  console.log(action)
  try {
    // const response = yield call(
    //   fetchLiveAccountsAgent
    // );

    const account_name  = action.payload.account_name;
    const response = yield call(
        fetchLiveAccountsAgent,
        account_name
    );
    
    yield put(submitGetLiveAccountsSuccess(response || "No live accounts."));
  } catch (error) {
    yield put(submitGetLiveAccountsFailure(error.message));
  }
}

export function* watchGetLiveAccountsSaga() {
  yield takeLatest(SUBMIT_GET_LIVE_ACCOUNTS_REQUEST, submitGetLiveAccountsSaga);
}